import React from "react";
import PageBanner from "./PageBanner";

export default function PageHeader(props) {
  return <PageBanner {...props} />;
}
